goog.provide('el8.ptdata.ptRegistrationInfo');

goog.require('el8.model.base');

el8.ptdata.ptRegistrationInfo = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.addEvents();

    _class.addBoolean('patientUser', true);
    _class.addBoolean('patientUserDisabled', true);
    _class.addStringProperty('inviteStatus', true);
    _class.addStringProperty('inviteCode', true);
    _class.addStringProperty('inviteEmail', true);
    _class.addStringProperty('invitePhone', true);
    _class.addProperty('passportUsernames', true);

    _class.addDateTime('inviteTime', true);
    _class.addDateTime('expireTime', true);
    _class.addDateTime('registrationTime', true);
    _class.addDateTime('smsTime', true);

    var that = new _class({});

    // when the inviteStatus changes, the letter pane will need to update
    var super_populate = that.populate;
    that.populate = function(spec) {
        super_populate.call(that, spec);
        that.trigger(EVENTS.UPDATED);
    };

    return that;

})();

